export default {
    AvaliacaoDeNominata: axios.create({
      baseURL: process.env.VUE_APP_ENDPOINT_API + "avaliacao-de-nominata"
    })
  }


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/AvaliacaoDeNominata.js
// module id = ik8g
// module chunks = 32